try {
    require('./darkmode');
    window.$ = window.jQuery = require('jquery');
    const bootstrap = window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
    require('./navbar');
    require('./ad-blocker-detector');
} catch (e) {}
